import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '../../../components/ui/button';

/**
 * ColumnToggle - Dropdown for toggling column visibility
 */
const ColumnToggle = ({ visibleColumns, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const columns = [
    { id: 'name',    label: 'Name'        },
    { id: 'address', label: 'Address'     },
    { id: 'phone',   label: 'Phone'       },
    { id: 'email',   label: 'Email'       },
    { id: 'stage',   label: 'Stage'       },
    { id: 'card',    label: 'Card on File' },
    { id: 'created', label: 'Created'     },
    { id: 'actions', label: 'Actions'     },
  ];

  return (
    <div className="relative">
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2"
      >
        <Eye className="h-4 w-4" />
        Columns
      </Button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">
            {columns.map((column) => (
              <label
                key={column.id}
                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={visibleColumns[column.id]}
                  onChange={() => onToggle(column.id)}
                  className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                <span className="text-sm text-gray-700">{column.label}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ColumnToggle;
